import { inject } from "vue";
/**
 * Used to navigate within Vue Router
 * while controlling the animation.
 */
export const useIonRouter = () => {
    const { canGoBack, goBack, goForward, handleNavigate } = inject("navManager");
    const navigate = (location, routerDirection, routerAction, routerAnimation) => handleNavigate(location, routerAction, routerDirection, routerAnimation);
    const push = (location, routerAnimation) => navigate(location, "forward", "push", routerAnimation);
    const replace = (location, routerAnimation) => navigate(location, "root", "replace", routerAnimation);
    const back = (routerAnimation) => goBack(routerAnimation);
    const forward = (routerAnimation) => goForward(routerAnimation);
    return {
        canGoBack,
        push,
        replace,
        back,
        forward,
        navigate,
    };
};
//# sourceMappingURL=router.js.map